import ApiService from '@/services/ApiService';
import ApiEndpoints from '@/config/ApiEndpoints';

export default class RequestToResetPassword {
    /**
     * ApiService instance.
     *
     * @var {ApiService}
     */
    apiService

    /**
     * RequestToResetPassword constructor.
     *
     * @returns {void}
     */
    constructor() {
        this.apiService = new ApiService(process.env.VUE_APP_API_URL);
    }

    /**
     * Send request for password reset.
     *
     * @param {String} email
     *
     * @returns {Promise}
     */
    handle(email) {
        return this.apiService
            .post(ApiEndpoints['auth.forgot-password.store'], {
                email: email,
            });
    }
}
